import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getAllProjects } from 'actions/projects';
import LoadingIndicator from 'ui/LoadingIndicator';
import { allProjectsUiSelector } from 'reducers/ui/allProjects/selectors';

const ProjectsSetup = ({ children }) => {
  const dispatch = useDispatch();
  const allProjectsUi = useSelector(allProjectsUiSelector);
  const areProjectsLoading = allProjectsUi.get('loader');

  useEffect(() => {
    dispatch(getAllProjects());
  }, [dispatch]);

  if (areProjectsLoading) {
    return <LoadingIndicator cover />;
  }

  return children;
};

ProjectsSetup.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProjectsSetup;
